module.exports = __webpack_public_path__ + "img/sign-in-pic.8da097d0.png";